import React, { useState, useContext, useEffect } from "react";
import ButtonComponent from "../components/basic/ButtonComponent";
import { createFolderDomeniu } from "../backend/FileUploadService";
import TextAreaComponent from "../components/basic/TextAreaComponent";
import { Row, Col } from "react-bootstrap";
import { RefreshContext } from "../context/RefreshContext";

const ModalFolderDomeniuCreate = ({
  locationType,
  closeModal,
  refreshFoldereDomeniu
}) => {
  const [descriere, setDescriere] = useState("");
  const { blocking, setBlocking } = useContext(RefreshContext);

  const createFolder = async () => {
    try {
      setBlocking(true)
      await createFolderDomeniu(locationType, descriere);
      refreshFoldereDomeniu();
      closeModal();
    } catch (err) {
      console.error(err);
    }
    finally {
      setBlocking(false)
    }
  };

  return (
    <Row>
      <Col className="text-center">
        <div className="text-center">
          <TextAreaComponent
            placeholder="Nume folder"
            rows={3}
            cols={50}
            value={descriere}
            onChange={e => {
              setDescriere(e.target.value);
            }}
            autoFocus
          />
        </div>
        <div className="text-center">
          <ButtonComponent
            text={"Adauga"}
            onClick={createFolder}
            variant={"primary"}
            disabled={blocking}
          />
        </div>
      </Col>
    </Row >
  );
};

export default ModalFolderDomeniuCreate;
